import React, { forwardRef } from 'react';

const CalendarWithoutDates = ({ width = 16, height = 16, color = '#7F38E9', ...rest }, ref) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...rest}>
      <path
        d="M1.33594 7.9974C1.33594 5.48324 1.33594 4.22616 2.11699 3.44511C2.89803 2.66406 4.15511 2.66406 6.66927 2.66406H9.33594C11.8501 2.66406 13.1072 2.66406 13.8882 3.44511C14.6693 4.22616 14.6693 5.48324 14.6693 7.9974V9.33073C14.6693 11.8449 14.6693 13.102 13.8882 13.883C13.1072 14.6641 11.8501 14.6641 9.33594 14.6641H6.66927C4.15511 14.6641 2.89803 14.6641 2.11699 13.883C1.33594 13.102 1.33594 11.8449 1.33594 9.33073V7.9974Z"
        stroke={color}
        strokeWidth="1.00781"
      />
      <path d="M4.66406 2.67188V1.67188" stroke={color} strokeWidth="1.00781" strokeLinecap="round" />
      <path d="M11.3359 2.67188V1.67188" stroke={color} strokeWidth="1.00781" strokeLinecap="round" />
      <path d="M1.67188 6H14.3385" stroke={color} strokeWidth="1.00781" strokeLinecap="round" />
    </svg>
  );
};

export default forwardRef(CalendarWithoutDates);
